module.exports = __webpack_public_path__ + "img/eden-logo.73fbf7c4.svg";